import React, { useState } from 'react';
import { Form, Input, DatePicker, Button, Row, Col, message } from 'antd';
import axiosInstance from '../../services/axiosInstance';
import moment from 'moment';

const TimeDifferenceOrder = ({ handleClose }) => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const handleFinish = async (values) => {
        setLoading(true);
        try {
            const start_date = values.dates[0].format('YYYY-MM-DD');
            const end_date = values.dates[1].format('YYYY-MM-DD');
            const email = values.email;

            const params = {
                start_date,
                end_date,
                email,
            };

            const response = await axiosInstance.get('/task/v2/export-tasks-csv/', {
                params,
                responseType: 'blob',
            });

            if (response.status === 200) {
                const blob = new Blob([response.data], {
                    type: response.headers['content-type'],
                });

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = `${moment().format('DD-MM-YYYY hh:mm A')}`;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);
                message.success('Sheet Download Successfully');
                handleClose();

                return { success: true };
            } else {
                message.error('Something went wrong');
            }
        } catch (err) {
            if (
                err?.response?.data instanceof Blob &&
                err?.response?.headers['content-type']?.includes('application/json')
            ) {
                const reader = new FileReader();
                reader.onload = () => {
                    try {
                        const errorJson = JSON.parse(reader.result);
                        const errorMsg =
                            errorJson?.message ||
                            errorJson?.detail ||
                            'Something went wrong while downloading the sheet.';
                        message.error(errorMsg);
                    } catch (parseErr) {
                        message.error('An unknown error occurred.');
                    }
                };
                reader.readAsText(err.response.data);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Form form={form} layout="vertical" onFinish={handleFinish}>
            <Row style={{ width: '100%' }}>
                <Col span={24}>
                    <Form.Item
                        label="Select Date Range"
                        name="dates"
                        rules={[{ required: true, message: 'Please select date range' }]}
                    >
                        <DatePicker.RangePicker style={{ width: '100%' }} />
                    </Form.Item>
                </Col>
            </Row>
            <Row style={{ width: '100%' }}>
                <Col span={24}>
                    <Form.Item
                        label="Email"
                        name="email"
                        rules={[
                            { required: true, message: 'Please enter email' },
                            { type: 'email', message: 'Please enter a valid email' },
                        ]}
                    >
                        <Input placeholder="Enter email" />
                    </Form.Item>
                </Col>
            </Row>
            <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-end' }}>
                <Button type="primary" htmlType="submit" loading={loading}>
                    Submit
                </Button>
            </div>
        </Form>
    );
};

export default TimeDifferenceOrder;
